import { Controller } from "@hotwired/stimulus"

// Carga una imagen via fetch solo cuando el elemento es visible en el viewport.
// Usa IntersectionObserver para evitar disparar N requests simultaneos al montar
// la pagina — solo carga los thumbnails que el usuario realmente ve.
//
// Uso:
//   <div data-controller="manage--lazy-image"
//        data-manage--lazy-image-url-value="/path/to/thumbnail.json">
//     <img data-manage--lazy-image-target="image" class="hidden ..." alt="...">
//   </div>
//
// El endpoint debe responder JSON: { "url": "https://..." }
// Si url es null/vacio, no se muestra nada.
export default class extends Controller {
  static targets = ["image"]
  static values = { url: String }

  connect() {
    if (!this.urlValue) return

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.observer.disconnect()
            this.load()
          }
        })
      },
      { rootMargin: "200px" }
    )

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  async load() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" }
      })
      if (!response.ok) return

      const data = await response.json()
      if (!data.url) return

      this.imageTarget.src = data.url
      this.imageTarget.classList.remove("hidden")
    } catch {
      // Fallo silencioso — se queda el placeholder
    }
  }
}
